import React from 'react';
import ServicesChartsDataProvider from './contexts/ServicesChartsDataContext';
import MonthlyUtilization from './MonthlyUtilization';

const MonthlyUtilizationWrapper = () => {
    return (
        <ServicesChartsDataProvider>
            <MonthlyUtilization />
        </ServicesChartsDataProvider>
    );
};

export default MonthlyUtilizationWrapper;
